import { getUrlSearchParam } from '@ui/utils/urlSearchParam';

export const getIsDebug = () => {
  const searchParam = getUrlSearchParam();
  if (!searchParam) return false;

  const isDebug = searchParam.get('isDebug') === 'true';

  return isDebug && process.env.APP_ENV !== 'prod';
};

export const getIsFreezeLivePrice = () => {
  const searchParam = getUrlSearchParam();
  if (!searchParam) return false;
  const isDebug = getIsDebug();
  if (!isDebug) return false;

  const freeze = searchParam.get('freezeLivePrice') === 'true';

  return freeze;
};
